import React, { useEffect, useState } from "react";
import closelogo from "../../images/cerrar.png"
import SkillsFolder from "../SkillsFolder/SkillsFolder";
import AboutFolder from "../AboutFolder/AboutFolder";
import ProjectFolder from "../ProjectsFolder/ProjectsFolder";

const Folder = (props) => {
    const [title, setTitle] = useState("")

    function close(){
        props.close(0)
    }

    useEffect(()=>{
        if(props.show === 1) setTitle("About me")
        else if (props.show === 2) setTitle("Projects")
        else if (props.show === 3) setTitle("Skills")
    },[props.show])

    return(
        <div className="folder">
            <div className="folderHeader">
                <div>
                    <p>{title}</p>
                    <img className="closeLogo" src={closelogo} alt="" onClick={close}/>
                </div>
            </div>
            <div className="folderBody">
                {props.show == 1 && <AboutFolder/>}
                {props.show == 2 && <ProjectFolder/>}
                {props.show == 3 && <SkillsFolder/>}
            </div>

        </div>
    )
}

export default Folder